import { render, staticRenderFns } from "./project_structure.vue?vue&type=template&id=93756148&scoped=true"
import script from "./project_structure.vue?vue&type=script&lang=js"
export * from "./project_structure.vue?vue&type=script&lang=js"
import style0 from "./project_structure.vue?vue&type=style&index=0&id=93756148&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93756148",
  null
  
)

export default component.exports